export const staticProducts = [
    {
        id: 1,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5n_1629507833231.jpg",
        title: "AMD Ryzen 5 5600x 6-Core 12-Thread processor",
        usage: "1 year usage",
        seller: {
            name: "PC Parts & Bros",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00,
        category: "CPUs"
    },
    {
        id: 2,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/6a_1629675541139.jpg",
        title: "Corsair Vengeance LPX 16GB DDR4 2400MHz",
        usage: "< 1 year usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00,
        category: "Cases"
    },
    {
        id: 3,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/77_1630362733942.jpeg",
        title: "BNIB Asus PRIME B550-PLUS ATX",
        usage: "5 year usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 4,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/at_1633394420046.jpeg",
        title: "Rosewill 400W Power Supply (Non-Modular)",
        usage: "1 year usage",
        usage: "1 month usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 5,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5i_1629500385891.jpg",
        title: "ASUS TUF GAMING B30 Motherboard",
        usage: "> 4 year usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00,
        category: "Motherboard"
    },
    {
        id: 6,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/bc_1633715662784.JPG",
        title: "EVGA SuperNOVA 650W G5 80 Plus Gold Power Supply",
        usage: "21 day usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 7,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/b9_1633656138416.jpg",
        title: "Apevia 500W SFX Power Supply",
        usage: "< month usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 8,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/aj_1632957013789.JPEG",
        title: "AMD Ryzen 5 5600x 6-Core 12-Thread processor",
        usage: "1 year usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00,
        category: "CPUs"
    },
    {
        id: 9,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5n_1629507833231.jpg",
        title: "AMD Ryzen 5 5600x 6-Core 12-Thread processor",
        usage: "1 year usage",
        seller: {
            name: "PC Parts & Bros",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00,
        category: "CPUs"
    },
    {
        id: 10,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/6a_1629675541139.jpg",
        title: "Corsair Vengeance LPX 16GB DDR4 2400MHz",
        usage: "< 1 year usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 11,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/77_1630362733942.jpeg",
        title: "BNIB Asus PRIME B550-PLUS ATX",
        usage: "5 year usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 12,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/at_1633394420046.jpeg",
        title: "Rosewill 400W Power Supply (Non-Modular)",
        usage: "1 year usage",
        usage: "1 month usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 13,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/5i_1629500385891.jpg",
        title: "ASUS TUF GAMING B30 Motherboard",
        usage: "> 4 year usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00,
        category: "Motherboard"
    },
    {
        id: 14,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/bc_1633715662784.JPG",
        title: "EVGA SuperNOVA 650W G5 80 Plus Gold Power Supply",
        usage: "21 day usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 15,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/b9_1633656138416.jpg",
        title: "Apevia 500W SFX Power Supply",
        usage: "< month usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    },
    {
        id: 16,
        image: "https://storage.googleapis.com/jawa-apps.appspot.com/product/aj_1632957013789.JPEG",
        title: "AMD Ryzen 5 5600x 6-Core 12-Thread processor",
        usage: "1 year usage",
        seller: {
            name: "Calvin Roger",
            city: "Kokshetau"
        },
        description: "New in Box. Got in Newegg combo and do not need. AMD B550 (Ryzen AM4) ATX gaming motherboard with PCIe 4.0, dual M.2, 10 DrMOS power stages, 2.5 Gb Ethernet, HDMI, DisplayPort, SATA 6 Gbps, USB 3.2 Gen 2 Type-A and Type-C, and Aura Sync RGB lighting support https://www.asus.com/us/Motherboards-Components/Motherboards/TUF-Gaming/TUF-GAMING-B550-PLUS/",
        cost: 120.00
    }
]